/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { HiDocumentAdd } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, clientSideUrl, RoutePath } from "../../../utility/Constant";

const GalleryCreate = () => {
  const { galleriesApi } = apiPath;
  const { aboutUsGalleries } = RoutePath;
  const navigate = useNavigate();

  const imagesData = [];


  const data = [
    {
      elementType: "input",
      label: "country name",
      type: "Text",
      name: "country_name",
      required: false,
    },
    {
      elementType: "input",
      label: "title",
      type: "Text",
      name: "title",
      required: false,
    },
    {
      elementType: "textField",
      label: "short description",
      type: "Text",
      name: "short_description",
      required: false,
    },
  ];

  const nestedData = [
    {
      elementType: "gFile",
      label: "Gallery Image",
      name: "gallery_img",
      multipleData: imagesData,
      multiple: true,
      required: false,
    },
  ];

  const useData = data.concat(nestedData);

  const update = async (data) => {
    let { gallery_img, ...rest } = data;
    if (!Array.isArray(gallery_img)) {
      gallery_img = gallery_img ? [gallery_img] : [];
    }
    rest.gallery_img = gallery_img;
    rest.gallery_title = "GALLERY";
    // rest.galleryId = rest.galleryId || Math.floor(Math.random() * 100000);



    const res = await updateData(galleriesApi, rest, null, true);
    if (res?.length > 0) {
      setTimeout(() => {
        window.location.href = "/" + aboutUsGalleries;
      }, 600);
    }
  };

  return (
    <div>
      <div className="md:pl-8 my-4">
        <h1 className="font-oswald font-bold text-xl md:text-2xl -mb-10 uppercase">
          <HiDocumentAdd className="inline w-8 h-8 mb-1" /> Add new gallery
        </h1>
      </div>
      <GlobalForm
        data={useData}
        nestedData={nestedData}
        nestedGalleryData={nestedData}
        update={update}
      />
    </div>
  );
};

export default GalleryCreate;
